import * as r from 'ramda';

export default function createOptIn(
  cookieConsent,
) {
  return function OptIn(
    settings,
    expires,
  ) {
    const map = r.pipe(
      r.map(r.prop('id')),
      r.invertObj,
    )(settings);
    const values = r.map(r.prop('value'), settings);

    cookieConsent(map, { expires }).set(values);

    return Promise.resolve(true);
  }
}
